import {
  CustomerSubscriptionAvailabilityApiModel,
  CustomerSubscriptionAvailabilityModel,
  CustomerSubscriptionAvailabilityResponseModel,
} from './subscriptionAvailability.model';
import { customerSubscriptionAdapter } from '../customerSubscription.adapter';

export const subscriptionAvailabilityAdapter = (
  subscriptionAvailability: CustomerSubscriptionAvailabilityApiModel
): CustomerSubscriptionAvailabilityModel => ({
  subscription: customerSubscriptionAdapter(
    subscriptionAvailability.subscription
  ),
  isClaimAvailable: subscriptionAvailability.is_claim_available,
  isClaimAvailableInNextPeriod:
    subscriptionAvailability.is_claim_available_in_next_period,
  isCourseClaimed: subscriptionAvailability.is_course_claimed,
  coursesClaimed: subscriptionAvailability.courses_claimed,
  coursesAvailable: subscriptionAvailability.courses_available,
  claimPeriodEnd: subscriptionAvailability.claim_period_end,
  nextClaimPeriodStart: subscriptionAvailability.next_claim_period_start,
});

export const customerSubscriptionResponseAdapter = ({
  data,
}: CustomerSubscriptionAvailabilityResponseModel): CustomerSubscriptionAvailabilityModel =>
  subscriptionAvailabilityAdapter(data.data);
